import React from 'react';
import './Map.css';

const Map = () => {
  return (
    <div className="map-container">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d54479.82651084644!2d74.32316104466838!3d31.414424825379708!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391907e9f9c1f2e7%3A0x6fafeb7c04b098af!2sSoftwood%20Pvt.%20Ltd.!5e0!3m2!1sen!2s!4v1744454038076!5m2!1sen!2s"
        width="100%"
        height="450"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Softwood Pvt. Ltd. Location"
      ></iframe>
    </div>
  );
};

export default Map; 
